/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import InternalAccountGridView from "../../../../components/Accounts/InternalAccount/InternalAccountGridView/index.jsx";
import InternalAccountListView from "../../../../components/Accounts/InternalAccount/InternalAccountListView/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import {
  addInternalAccountLabel,
  getAllInternalAccounts,
  removeInternalAccountLabel,
  resetInternalToggle,
  setInternalToggle,
} from "../../../../redux/features/accounts/internalAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  TimelineConfiguration,
} from "../../../../utils/configurationProvider.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import useMultiSelect from "../../../../utils/useMultiSelect.js";
import "./index.css";
import globalText from "../../../../utils/globalText.js";

const InternalAccountViewAll = ({
  id,
  typepop,
  onClosepop,
  handleButtonClick,
  associateAccount,
  associatepanNumber,
  associateaccountNumber,
  setOpenInternalAssociate,
  setOpenBeneAssociate,
  beneAccountId,
  accountType,
  flow,
  setTxnPayLoad,
  txnPayLoad,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  BeneTxnAssocAcct,
  setAssociateModalOpen,
  associateTxn,
  scheduleIntenralTxn,
  remAccount,
  remIFSC,
  remPan,
  typePanBank,
  activeType,
  onCardNavigate,
}) => {
  const location = useLocation();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const navigate = useNavigate();
  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams(
      location?.state &&
        location?.state?.approvalStatus &&
        location?.state?.approvalStatus !== "all"
        ? {
            status: location?.state?.approvalStatus,
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          }
        : {
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          },
    );
  const convertDate = (dateString) => {
    if (!dateString) return;
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };
  const dispatch = useDispatch();
  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();
  //variable section
  const internalAccount = "internalAccount";
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  //useref section
  const dropdownRef = useRef(null);
  const filterRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const scrollContainerRef = useRef(null);
  const lastElementRef = useRef();
  const sidebarRefm = useRef(null);
  const { showRestrictedAction } = useRestrictedAction();
  //useState section
  const [balanceType] = useState("Pan");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [LabelSearchText, setLabelSearchText] = useState(
    !associateAccount ? searchParam.get("label")?.split(",") || [] : "",
  );
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    !associateAccount
      ? searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne
      : GlobalConfiguration.lengthCheckOne,
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(
    location?.state && !associateAccount
      ? location?.state?.approvalStatus
      : !associateAccount
        ? searchParam.get("status") || ""
        : "",
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarOpenm, setIsSidebarOpenm] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [searchUserText, setSearchUserText] = useState(
    !associateAccount ? searchParam.get("search") || "" : "",
  );
  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const [accountNumber, setAccountNumber] = useState(
    searchParam.get("accno") || "",
  );
  const [searchIfscText, setSearchIfscText] = useState("");
  const [isIfsc, setIsIfsc] = useState(searchParam.get("ifsc") || "");
  const [panNumber, setPanNumber] = useState(
    !associateAccount
      ? searchParam.get("panno") || remPan || associatepanNumber || ""
      : associatepanNumber || remPan || "",
  );
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchAccountText, setSearchAccountText] = useState("");
  const [isPopoverOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(
    !associateAccount
      ? searchParam.get("pagesize") || PaginationConfiguration.paginationSmall
      : PaginationConfiguration.paginationSmall,
  );
  const [mainData, setMainData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isWheelScrolling, setIsWheelScrolling] = useState(false);
  const [callFilter] = useState(null);
  const { services } = useSelector((state) => state.refreshToken);
  const [pageSize, setPageSize] = useState(
    !associateAccount
      ? searchParam.get("pagesize") || PaginationConfiguration.paginationSmall
      : PaginationConfiguration.paginationSmall,
  );
  const [getFilterStatus] = useState();
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [accountNameValue] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  //Selector section

  const isFilterActive =
    startDateFilter &&
    endDateFilter &&
    startDateFilter !== GlobalConfiguration.lengthCheckZero &&
    endDateFilter !== GlobalConfiguration.lengthCheckZero &&
    !isNaN(Number(startDateFilter)) &&
    !isNaN(Number(endDateFilter));

  const filteredData = accumulatedData;
  const selectableAccounts = accumulatedData?.map((item) => ({
    ...item,
    id: item?.id,
  }));

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const onMount = async () => {
    await fetchData();
    let availableLabels = sessionStorage?.getItem("internalAccountLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  };
  const { toggle } = useSelector((state) => state.internalAccount);

  //Write Function section

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleToggle = (newToggleValue) => {
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });

      if (!showSearchBar && !isSidebarOpen) {
        dispatch(setInternalToggle(newToggleValue));
      }
    }
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);

    if (
      isLabelClicked &&
      value === PaginationConfiguration.paginationSmall &&
      LabelAccounts?.length > PaginationConfiguration.paginationSmall
    ) {
      handleChange(LabelAccounts, setLabelAccounts, value, LabelAccounts);
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);

    toggleDropdown();
  };

  const handleFilterCategory = (selectedCategoryName) => {
    setCurrentCategory(selectedCategoryName);
  };

  const handleClickOutside = (event) => {
    if (event.target.className === "internal-account-black") {
      setIsSidebarOpen(false);
    }
    if (sidebarRefm.current && !sidebarRefm.current.contains(event.target)) {
      setIsSidebarOpenm(false);
    }
  };

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
      setIsWheelScrolling(false);
    }
  }, []);

  const handleWheel = useCallback((event) => {
    setIsWheelScrolling(true);
  }, []);

  const handleDateChange = (dates) => {
    if (!dates) {
      setStartDate(null);
      setEndDate(null);
      setStartDateFilter("");
      setEndDateFilter("");
      return;
    }

    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    // Convert Date objects to timestamps (in seconds) for API calls
    if (start && end) {
      const startTimestamp = Math.floor(
        start.getTime() / TimelineConfiguration?.totalSeconds,
      );
      const endTimestamp = Math.floor(
        end.getTime() / TimelineConfiguration?.totalSeconds,
      );
      setStartDateFilter(startTimestamp);
      setEndDateFilter(endTimestamp);
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const handlePagination = (page) => {
    if (filterRef.current) {
      filterRef.current.scrollTop = GlobalConfiguration.lengthCheckZero;
    }
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };


  const fetchData2 = async () => {
    let data = [];
    setLoadingData(true);

    data = labels
      ?.filter((itm) => {
        return itm.includes(searchUserTextDebounce);
      })
      ?.map((val) => {
        return { id: val, Label: val };
      });
    setInputData(data);
    setLoadingData(false);
  };


  const totalRecordCount = Number(mainData?.total_count || GlobalConfiguration.lengthCheckZero);

  const effectiveSelectCap =
    totalRecordCount > GlobalConfiguration.lengthCheckZero && totalRecordCount <= Number(selectedValue)
      ? totalRecordCount
      : Number(selectedValue);

  const isAllSelected =
    LabelAccounts?.length === effectiveSelectCap && effectiveSelectCap > GlobalConfiguration.lengthCheckZero;

  const handleSelectAll = () => {
    handleMultiSelectAll(
      LabelAccounts,
      setLabelAccounts,
      selectedValue,
      selectableAccounts,
    );
  };

  const handleLabelAccountSelect = (account) => {
    handleSingleSelect(LabelAccounts, setLabelAccounts, selectedValue, {
      ...account,
      id: account?.id,
    });
  };

   async function fetchData() {
    setLoading(true);
    try {
      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
      };

      const addParamsBasedOnSelection = () => {
        if (currentStatus !== "all") {
          queryParams.approval_status =
            currentStatus === "require approval" ? "pending" : currentStatus;
        }
        if (currentCategory !== "") {
          queryParams.categoryName = currentCategory;
        }
        if (
          startDateFilter !== "" &&
          endDateFilter !== "" &&
          startDateFilter &&
          endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date = startDateFilter;
          queryParams.end_date = endDateFilter;
        }
        if (accountNumber !== "" || remAccount) {
          queryParams.bank_account_no = remAccount ? remAccount : accountNumber;
        }
        if (typePanBank === "BeneAccPanBankSwitch") {
          if (remPan) {
            queryParams.pan = remPan.toUpperCase();
          }
        } else {
          if (panNumber !== "") {
            queryParams.pan = panNumber;
          }
        }
        if (searchUserText !== "") {
          queryParams.search_string = searchUserText;
        }
        if (LabelSearchText?.length !== GlobalConfiguration.lengthCheckZero) {
          queryParams.labels = LabelSearchText;
        }
        if (typePanBank === "BeneAccPanBankSwitch") {
          if (remIFSC) {
            queryParams.ifsc = remIFSC.toUpperCase();
          }
        } else {
          if (isIfsc !== "") {
            queryParams.ifsc = isIfsc;
          }
        }

        if (
          internalAccount === "internalAccount" ||
          accountType === "internal" ||
          flow === "internalTxn" ||
          associateTxn === "associateTxn"
        ) {
          queryParams.type = "internalAccount";
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(getAllInternalAccounts(queryParams));
      const newData = response?.payload?.internal_accounts || [];
      setMainData(response?.payload);
      setAccumulatedData(newData);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    fetchData();
    setLabelAccounts([]);
    setisLabelClicked(false);
    setShowSearchBar(false);
    setSearchUserText("");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign, recordIdsFromPopup) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(LabelAccounts)
            ?.map((item) => item?.id || item)
            ?.filter(Boolean);
    const res = await dispatch(
      addInternalAccountLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (addInternalAccountLabel.fulfilled.match(res)) {
      await fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addInternalAccountLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (addInternalAccountLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (
    labelsToUnassign,
    recordIdsFromPopup,
  ) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(LabelAccounts)
            ?.map((item) => item?.id || item)
            ?.filter(Boolean);
    const res = await dispatch(
      removeInternalAccountLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeInternalAccountLabel.fulfilled.match(res)) {
      await fetchData();
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeInternalAccountLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (removeInternalAccountLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

   const clearFilter = () => {
    handleClearSearchParam();
    handleFilterCategory("");
    setStartDate(null);
    setEndDate(null);
    setStartDateFilter("");
    setEndDateFilter("");
    setIsIfsc("");
    setLabelSearchText("");
    setShowSearchBar(false);
    setisLabelClicked(false);
    setSearchUserText("");
    setCurrentStatus("");
    if (
      associateTxn === "associateTxn" ||
      BeneTxnAssocAcct ||
      accountType === "internal"
    ) {
      setPanNumber(associatepanNumber || remPan || "");
    } else {
      setPanNumber("");
    }

    if (accountType !== "internal") {
      setCurrentStatus("");
    }

    if ((associateAccount || BeneTxnAssocAcct) && balanceType === "Bank") {
      setSearchIfscText(searchIfscText);
      setSearchAccountText(searchAccountText);
      setAccountNumber(accountNumber);
    } else {
      setSearchIfscText("");
      setSearchAccountText("");
      setAccountNumber("");
    }
    handleClearSearchParam();
  };

  const handleSubmit = (key, value) => {
    if (typepop !== "popup") {
      handleSearchParams(key, value);
    }
  };

  //useEffect section
  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);


  useEffect(() => {
    if (callFilter) {
      callFilter();
    }
  }, [balanceType]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, [handleKeyDown, handleWheel]);


  useEffect(() => {
    if (active?.length) {
      fetchData2();
    }
  }, [active, searchUserTextDebounce]);

 
  useEffect(() => {
    onMount();
  }, [
    currentPage,
    currentStatus,
    currentCategory,
    searchUserText,
    startDateFilter,
    endDateFilter,
    accountNumber,
    pageSize,
    panNumber,
    isIfsc,
    LabelSearchText,
    markerData,
    remAccount,
    remIFSC,
    remPan,
    associatepanNumber,
  ]);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isSidebarOpen, getFilterStatus]);

  useEffect(() => {
    if (
      associateTxn === "associateTxn" ||
      BeneTxnAssocAcct ||
      accountType === "internal"
    ) {
      if (associatepanNumber) {
        setPanNumber(associatepanNumber);
      } else if (remPan) {
        setPanNumber(remPan);
      }
    } else if (!remPan?.length) {
      setPanNumber("");
    }
  }, [associateTxn, remPan, associatepanNumber, BeneTxnAssocAcct, accountType]);

  useEffect(() => {
    if (isSidebarOpenm) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpenm, getFilterStatus]);

  // Sync startDate and endDate from timestamps when they exist but Date objects don't
  useEffect(() => {
    if (startDateFilter && endDateFilter && !startDate && !endDate) {
      const start = new Date(
        startDateFilter * IntervalConfiguration.intervalMedium,
      );
      const end = new Date(
        endDateFilter * IntervalConfiguration.intervalMedium,
      );
      setStartDate(start);
      setEndDate(end);
    }
  }, [startDateFilter, endDateFilter]);



  useEffect(() => {
    dispatch(resetInternalToggle());

    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

 

  return (
    <div
      id="internalAccViewAllContainer"
      className={`bg-primary-bg flex relative flex-col overflow-hidden ${
        typepop === "popup" ? "h-height-full relative" : ""
      }`}
    >
      <div
        className={`bg-primary-bg flex flex-col relative ${
          typepop === "popup" ? "h-height-full" : "h-screen"
        }`}
        style={{
          overflow: isSidebarOpen && "hidden",
        }}
      >
        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
            <CommonAssignLabelPopup
              headerTitle={globalText?.ASSIGN_UNASSIGN_LABELS}
              headersubtext={globalText?.LABELS_STATS_USAGE_NOTE}
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={LabelAccounts}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
              type="viewall"
            />
          </div>
        )}
        {(isPopoverOpen || isSidebarOpen || showInnerSearchBar) && (
          <div className="absolute top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-light-opacity z-z-index-header"></div>
        )}

        <div
          className="flex flex-col justify-center items-start bg-primary-nav"
          style={{
            transition: showSearchBar
              ? "all  var(--animation-fast) ease-in"
              : "all  var(--animation-fast) ease-in",
            top: typepop === "popup" ? "var(--bottom-sm)" : "var(--top-base)",
            borderTopRightRadius:
              typepop === "popup"
                ? "var(--border-radius-md)"
                : "var(--border-none)",
            borderTopLeftRadius:
              typepop === "popup"
                ? "var(--border-radius-md)"
                : "var(--border-none)",
            width: "var(--width-full)",
            zIndex:
              typepop === "popup"
                ? "var(--z-index-tooltip)"
                : "var(--z-index-overlay)",
          }}
        >
          <div
            className={`${typepop === "popup" ? "" : "min-h-navbar-height mb-margin-xl"} z-z-index-header w-full hidden Qsmd:block `}
          ></div>
          <div
            className={`flex flex-col items-center justify-center z-z-index-header Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act relative ${typepop === "popup" ? " w-full Qmd:w-full-popup-width" : "w-full-width"}`}
          >
            <TopNavComponent
              topNavCtaBtn1Needed={isLabelClicked}
              topNavCtaBtn1Props={
                isLabelClicked
                  ? {
                      btnText: `${LabelAccounts?.length ? "Clear" : "Cancel"}`,
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: (e) => {
                        const textContent = e.target.textContent.trim();
                        if (textContent === "Clear") {
                          setLabelAccounts([]);
                        }
                        if (textContent === "Cancel") {
                          setisLabelClicked(false);
                        }
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: isSidebarOpen || showSearchBar,
                      hoverOption: "white",
                    }
                  : undefined
              }
              topNavCtaBtn2Needed={isLabelClicked}
              topNavCtaBtn2Props={
                isLabelClicked
                  ? {
                      btnText: globalText?.ASSIGN_LABELS,
                      btnType: "button",
                      enabledBgColor: LabelAccounts?.length
                        ? "var(--text-primary)"
                        : "var(--text-disabled)",
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (LabelAccounts?.length) {
                          setIsLabelPopupOpen(true);
                        }
                      },
                      enabledTextColor: LabelAccounts?.length
                        ? "var(--primary-bg)"
                        : "Var(--text-primary)",
                      isDisabled:
                        isSidebarOpen ||
                        showSearchBar ||
                        !LabelAccounts?.length,
                      hoverOption: "black",
                      inActiveVariantNeeded: true,
                    }
                  : undefined
              }
              BottomSubText={
                isLabelClicked
                  ? globalText?.SELECT_ACCOUNTS_FOR_LABELS
                  : undefined
              }
              BottomSubTextVaraint="primary"
              isSelectionView={isLabelClicked && true}
              isToggleNeeded={true}
              toggleProps={
                !isLabelClicked
                  ? {
                      title: !toggle ? " List view" : "Grid view",
                      state: toggle,
                      isDisabled: isSidebarOpen || showSearchBar,
                      handleClick: (e) => {
                        if (filterRef.current) {
                          filterRef.current.scrollTop =
                            GlobalConfiguration.lengthCheckZero;
                        }
                        handleToggle(!toggle);
                      },
                    }
                  : undefined
              }
              selectionText={`Account selected - ${LabelAccounts?.length || GlobalConfiguration.lengthCheckZero}`}
              selectionBtnProps={
                isLabelClicked
                  ? {
                      btnText: `Select up to ${Number(selectedValue)}`,
                      btnType: "button",
                      enabledBgColor: isAllSelected
                        ? "var(--positive-bg)"
                        : "var(--primary-nav-act)",
                      handleFunction: () => {
                        handleSelectAll();
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled:
                        loading ||
                        selectableAccounts?.length ===
                          GlobalConfiguration.lengthCheckZero,
                      hoverOption:
                        LabelAccounts?.length === Number(selectedValue)
                          ? "black"
                          : "white",

                      icon: isAllSelected
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                    }
                  : undefined
              }
              assignLabelNeeded={true}
              assignTagNeeded={true}
              assignLabelProps={
                !isLabelClicked
                  ? {
                      handleFunction: () => {
                        if (loading) return;
                        if (accountType === "internal") {
                          actionRestricted();
                          return;
                        } else if (typepop === "popup") {
                          actionRestricted();
                        } else if (
                          services?.includes("ALabel") &&
                          services?.includes("RLabel")
                        ) {
                          if (isSidebarOpen || showSearchBar) {
                            return;
                          }
                          setisLabelClicked((prev) => {
                            if (prev) {
                              setLabelAccounts([]);
                            }
                            return !prev;
                          });
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "ALabel,RLabel",
                            },
                          });
                        }
                      },
                      isDisabled:
                        loading ||
                        accountType === "internal" ||
                        typepop === "popup" ||
                        isSidebarOpen ||
                        showSearchBar,
                      enabledBgColor: "var(--primary-bg)",
                      isLoading: false,

                      hoverOption: "black",
                      buttonRef: null,
                      title:
                        globalText?.LABELS_STATS_USAGE_NOTE,
                    }
                  : undefined
              }
              filteredSearchProps={{
                isSortDisabled: loading,
                isFilterDisabled: loading,
                setShowInnerSearchBar: setShowInnerSearchBar,
                showSearchBar: showSearchBar,
                isSearchDisabled: isSidebarOpen || loading,
                onSearchInput: (val) => handleSearch(val),
                searchText: searchUserTextDebounce,
                searchPlaceholder: globalText?.SEARCH_INTERNAL_ACCOUNT,
                filterPlaceholder:
                  globalText?.SEARCH_PLACEHOLDER,
                filterItems: [
                  {
                    name: globalText?.SEARCH,
                    isMulti: false,
                    value: searchUserText,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("search", val);
                      setSearchUserText(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: globalText?.ACCOUNT_NUMBER,
                    short_name: "Int A/c",
                    isMulti: false,
                    value:
                      typePanBank === "BeneAccPanBankSwitch"
                        ? remAccount || accountNumber
                        : accountNumber,
                    displayValue: accountNameValue?.toLowerCase(),
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("accno", val);
                      setAccountNumber(val);
                    },
                    valueType: "string",
                    isDropdown: false,
                    isDisabled: loading
                      ? true
                      : (associateAccount ||
                            BeneTxnAssocAcct ||
                            associateTxn === "associateTxn") &&
                          activeType === "bank"
                        ? true
                        : false,
                  },
                  {
                    name: globalText?.IFSC,
                    short_name: globalText?.IFSC_CODE,
                    isMulti: false,
                    value:
                      typePanBank === "BeneAccPanBankSwitch"
                        ? remIFSC || isIfsc.toUpperCase()
                        : isIfsc.toUpperCase(),
                    setValue: (val) => {
                      handleSubmit("ifsc", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setIsIfsc(val);
                    },
                    valueType: "string",
                    isDropdown: false,
                    isDisabled: loading
                      ? true
                      : (associateAccount ||
                            BeneTxnAssocAcct ||
                            associateTxn === "associateTxn") &&
                          activeType === "bank"
                        ? true
                        : false,
                  },
                  {
                    name: globalText?.PAN_NUMBER_DETAILS,
                    short_name: globalText?.PAN_NUMBER,
                    isMulti: false,
                    value:
                      associateTxn === "associateTxn"
                        ? associatepanNumber
                        : activeType === "pan" &&
                            typePanBank === "BeneAccPanBankSwitch"
                          ? remPan
                          : panNumber?.toUpperCase(),
                    setValue: (val) => {
                      handleSubmit("pan", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setPanNumber(val);
                    },
                    valueType: "string",
                    isDropdown: false,
                    isDisabled:
                      loading ||
                      associateTxn === "associateTxn" ||
                      BeneTxnAssocAcct ||
                      accountType === "internal" ||
                      ((associateAccount || BeneTxnAssocAcct) &&
                        activeType === "pan"),
                  },

                  {
                    name: globalText?.LABELS,
                    short_name: "Lab",
                    isMulti: true,
                    value: LabelSearchText,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("label", val);
                      setLabelSearchText(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: loading ? true : false,
                  },
                ],
                filters: [
                  {
                    name: globalText?.ACCOUNT_STATUS,
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: currentStatus || "",
                    dropdownPlaceHolder: globalText?.SELECT_STATUS,
                    isDisable: false,
                    options: services?.includes("IAAccount")
                      ? [
                          "approved",
                          "require approval",
                          "rejected",
                          "blocked",
                          "archived",
                        ]
                      : [
                          "approved",
                          "pending",
                          "rejected",
                          "blocked",
                          "archived",
                        ],
                    statusPop: true,
                    handleChange: (val) => {
                      handleSubmit("status", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setCurrentStatus(val);
                    },
                  },
                  {
                    name: globalText?.DATE_RANGE,
                    filterType: globalText?.CALENDER?.toLowerCase(),
                    variant: "range",
                    size: "small",
                    value:
                      (startDate && endDate) ||
                      (startDateFilter && endDateFilter),
                    isDisable: false,
                    startDate:
                      startDate ||
                      (startDateFilter
                        ? new Date(
                            startDateFilter *
                              IntervalConfiguration.intervalMedium,
                          )
                        : null),
                    endDate:
                      endDate ||
                      (endDateFilter
                        ? new Date(
                            endDateFilter *
                              IntervalConfiguration.intervalMedium,
                          )
                        : null),
                    handleChange: (date) => {
                      handleSubmit("date", date);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleDateChange(date);
                    },
                  },
                ],
                isFilterClearAllDisabled: !(
                  (startDateFilter && endDateFilter) ||
                  currentStatus !== "" ||
                  loading
                ),
                isSearchClearAllDisabled: !(
                  (accountNumber?.length && accountNumber !== remAccount) ||
                  (isIfsc?.length && isIfsc !== remIFSC) ||
                  (panNumber?.length &&
                    panNumber !== remPan &&
                    panNumber !== associatepanNumber) ||
                  LabelSearchText?.length ||
                  searchUserText?.length ||
                  loading
                ),
                inputData: inputData,
                active: active,
                setActive: setActive,
                loadingData: loadingData,
                loading: loading,
                setLoading: setLoadingData,
                isShowSortBy: false,
                isShowFilter: true,
              }}
              ispagination={
                accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                  ? false
                  : true
              }
            />
          </div>
        </div>
        <div
          ref={scrollContainerRef}
          className={`${
            accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
            loading
              ? "pb-bottom-base"
              : isLabelClicked
                ? toggle
                  ? "Qsmd:pb-padding-base pb-[var(--topnavbar-min-height)]"
                  : "Qsmd:pb-padding-base pb-[var(--topnavbar-min-height)]"
                : toggle
                  ? ""
                  : ""
          } ${
            typepop === "popup"
              ? "h-full flex flex-col flex-1 overflow-y-auto overflow-hidden min-h-1"
              : "overflow-y-auto h-height-full flex-1 min-h-0"
          }`}
          style={{
            marginBottom: !isWheelScrolling && "var(--margin-base)",
          }}
          onKeyDown={(event) => {
            const blockedKeys = ["w", "s", "W", "S", "ArrowUp", "ArrowDown"];

            if (
              blockedKeys.includes(event.key) ||
              event.code === "KeyS" ||
              event.code === "KeyW"
            ) {
              event.preventDefault();
              if (toggle) event.stopPropagation();
              return false;
            }

            if (toggle) event.stopPropagation();
          }}
        >
          {loading ? (
            <div className="loader-container grid place-items-center w-full h-full">
              <Loader />
            </div>
          ) : !!filteredData?.length || !!accumulatedData?.length ? (
            <div
              style={{
                scrollPaddingTop: "var(--padding-md)",
                scrollPaddingBottom: "var(--padding-md)",
              }}
              className={`scroll flex flex-col items-center min-h-0 h-full-height ${
                showInnerSearchBar && "pointer-events-none"
              } w-full ${isSidebarOpen && "overflow-y-hidden"}`}
              ref={filterRef}
            >
              {!toggle ? (
                <InternalAccountGridView
                  id={id}
                  filterRef={filterRef}
                  data={accumulatedData}
                  lastElementRef={lastElementRef}
                  isSidebarOpen={showInnerSearchBar}
                  isPopoverOpen={isPopoverOpen}
                  typepop={typepop}
                  handleButtonClick={handleButtonClick}
                  internalAccount={internalAccount}
                  associateaccountNumber={associateaccountNumber}
                  associateAccount={associateAccount}
                  setOpenInternalAssociate={setOpenInternalAssociate}
                  balanceType={balanceType}
                  setOpenBeneAssociate={setOpenBeneAssociate}
                  showSearchBar={showSearchBar}
                  beneAccountId={beneAccountId}
                  txnPayLoad={txnPayLoad}
                  setTxnPayLoad={setTxnPayLoad}
                  setIsImps={setIsImps}
                  setIsNeft={setIsNeft}
                  onClosepop={onClosepop}
                  setIsRtgs={setIsRtgs}
                  accountType={accountType}
                  BeneTxnAssocAcct={BeneTxnAssocAcct}
                  setAssociateModalOpen={setAssociateModalOpen}
                  associateTxn={associateTxn}
                  flow={flow}
                  scheduleIntenralTxn={scheduleIntenralTxn}
                  isLabelClicked={isLabelClicked}
                  LabelAccounts={LabelAccounts}
                  handleLabelSelect={handleLabelAccountSelect}
                  isFilterActive={isFilterActive}
                  setlableInput={(e) => {}}
                  onCardNavigate={onCardNavigate}
                />
              ) : (
                <InternalAccountListView
                  id={id}
                  filterRef={filterRef}
                  data={accumulatedData}
                  isSidebarOpen={showInnerSearchBar}
                  page={currentPage}
                  isPopoverOpen={isPopoverOpen}
                  typepop={typepop}
                  handleButtonClick={handleButtonClick}
                  pageSize={pageSize}
                  internalAccount={internalAccount}
                  associateAccount={associateAccount}
                  setOpenInternalAssociate={setOpenInternalAssociate}
                  balanceType={balanceType}
                  showSearchBar={showSearchBar}
                  beneAccountId={beneAccountId}
                  txnPayLoad={txnPayLoad}
                  setTxnPayLoad={setTxnPayLoad}
                  setIsNeft={setIsNeft}
                  setIsImps={setIsImps}
                  setIsRtgs={setIsRtgs}
                  onClosepop={onClosepop}
                  flow="internalAcc"
                  accountType={accountType}
                  setOpenBeneAssociate={setOpenBeneAssociate}
                  setAssociateModalOpen={setAssociateModalOpen}
                  BeneTxnAssocAcct={BeneTxnAssocAcct}
                  isLabelClicked={isLabelClicked}
                  LabelAccounts={LabelAccounts}
                  handleLabelSelect={handleLabelAccountSelect}
                  isFilterActive={isFilterActive}
                  setlableInput={(e) => {}}
                  scheduleIntenralTxn={scheduleIntenralTxn}
                  onCardNavigate={onCardNavigate}
                />
              )}
            </div>
          ) : (
            <div
              className="flex flex-col items-center justify-center m-auto w-full h-full"
              style={{ overflowY: showSearchBar && "scroll" }}
            >
              <img
                src={ICONS?.NO_DATA_FOUND}
                alt={globalText?.NO_DATA_FOUND}
                className="w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
              />

              <p className="text-text-primary text-font-sm font-normal text-center font-open-sans mb-margin-sm">
               {globalText?.NO_DATA_FOUND}
              </p>

              <PrimaryButton
                enabledBgColor="var(--primary-nav-act)"
                btnText={globalText?.CLEAR_PARAMETERS}
                btnType="button"
                handleFunction={() => {
                  clearFilter();
                }}
                enabledTextColor="var(--text-primary)"
                hoverOption="white"
              />
            </div>
          )}
        </div>
        {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
          !loading && (
            <div
              className={`w-width-full z-z-index-content bg-primary-nav ${
                typepop === "popup"
                  ? "w-width-full Qmd:w-full_popup-width rounded-none Qmd:rounded-b-border-radius-md Qmd:rounded-t-none"
                  : "w-width-full rounded-none"
              } ${(isPopoverOpen || isSidebarOpen) && "pointer-events-none"}`}
            >
              <div
                className={`${
                  accountType === "internal" &&
                  filteredData?.length === GlobalConfiguration?.lengthCheckOne
                    ? "hidden"
                    : `block ${showInnerSearchBar ? "pointer-events-none" : ""}`
                }`}
              >
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  setIsOpen={setIsOpen}
                  typePopup={typepop === "popup"}
                />
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default InternalAccountViewAll;
